import Base from '@studiometa/js-toolkit';
import Swiper, { Autoplay } from 'swiper';

/**
 * Marque desktop class
 */
export default class Marques extends Base {
  static config = {
    name: 'Marques',
    refs: ['wrapper', 'slides[]'],
    options: {
      slider: Object,
    },
  };

  slider = null;

  /**
   * Mounted life-cycle
   */
  mounted() {
    if (this.$options.slider.slidesCount <= this.$options.slider.slidesMax.desktop) {
      return;
    }

    Swiper.use([Autoplay]);

    this.$el.classList.remove('brands--static');
    this.$el.classList.add('swiper');

    if (this.$refs.wrapper) {
      this.$refs.wrapper.classList.add('swiper-wrapper');
    }

    if (Array.isArray(this.$refs.slides)) {
      this.$refs.slides.forEach(($slide) => {
        $slide.classList.add('swiper-slide');
      });
    }

    this.slider = new Swiper(this.$el, {
      cssMode: true,
      loop: true,
      loopAdditionalSlides: 1,
      slidesPerView: 5,
      centeredSlides: true,
      grabCursor: true,
      autoplay: {
        delay: 4800,
        disableOnInteraction: false,
      },
    });
  }

  /**
   * Destroyed life-cycle
   */
  destroyed() {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }

    this.$el.classList.add('brands--static');
    this.$el.classList.remove('swiper');

    if (this.$refs.wrapper) {
      this.$refs.wrapper.classList.remove('swiper-wrapper');
    }

    if (Array.isArray(this.$refs.slides)) {
      this.$refs.slides.forEach(($slide) => {
        $slide.classList.remove('swiper-slide');
      });
    }
  }
}
